import { IconButton, IconButtonProps } from '@mui/material'
import { FileCopyOutlined } from '@mui/icons-material'
import * as React from 'react'
import copyTextToClipboard from '@/services/admin-service/copyTextToClipboard'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const copyText = async (text: string) => {
  await copyTextToClipboard(text)
  toast('copied')
}

export default function CopyComponent(props: {
  text: string
  iconStyle?: React.CSSProperties
  iconButtonProps?: IconButtonProps
}) {
  return (
    <>
      <IconButton
        size="small"
        style={{ fontSize: '0.8rem' }}
        onClick={() => {
          copyText(props.text?.toString() || '')
        }}
        {...props.iconButtonProps}
      >
        {' '}
        <FileCopyOutlined style={{ fontSize: '0.8rem', ...props.iconStyle }} />
      </IconButton>
      <ToastContainer position="bottom-right" autoClose={2000} />
    </>
  )
}
